<script>
    import Spinner from "@components/Spinner/Spinner.svelte";
</script>

<div class="gw-vp-spinner">
    <Spinner />
</div>

<style>
    .gw-vp-spinner {
        --gw-spinner-color: #d9d9d9;

        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
    }
</style>
